import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, {Component} from "react";
import _ from "lodash";
import {withStyles} from "@material-ui/core/styles";

import {getSharedStyles} from "../themes";
import {CircularProgress} from "@material-ui/core";
import PropTypes from "prop-types";
const styles = (theme) => ({
	...getSharedStyles(theme),
});

class InitialLoading extends Component {
	render() {
		const { classes } = this.props;
		return (<Grid container spacing={3}>
			<Grid item xs={12}>
				<Paper className={classes.paper} style={{padding: 30}}>
					<CircularProgress/>
					<span style={{fontSize: 20, color: '#999', fontStyle: 'italics', paddingLeft: 10}}>
							Fetching and calculating data...
					</span>
				</Paper>
			</Grid>
		</Grid>);
	}
}

InitialLoading.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
])(InitialLoading);
